import {
    SET_BATCH_FILES_TABLE_PAGINATION,
    GET_ALL_BATCH_FILES_BEGIN, GET_ALL_BATCH_FILES_SUCCESS, GET_ALL_BATCH_FILES_FAILURE,
    DOWNLOAD_BATCH_FILE_BEGIN, DOWNLOAD_BATCH_FILE_SUCCESS, DOWNLOAD_BATCH_FILE_FAILURE,
    UPLOAD_BATCH_FILE_BEGIN, UPLOAD_BATCH_FILE_SUCCESS, UPLOAD_BATCH_FILE_FAILURE
} from '../constants/ActionTypes'

const initialState = {

    // All Batch Files Table
    rowCount: 0,
    pagination: { pageIndex: 0, pageSize: 10 },
    
    // Get All Batch Files
    allBatchFiles: null,
    isLoadingAllBatchFiles: false,
    hasErrorAllBatchFiles: null,

    // Download Batch File
    downloadedBatchFile: null,
    isDownloadingBatchFile: false,
    hasErrorDownloadedBatchFile: null,

    // Upload Batch File
    uploadedBatchFile: null,
    isUploadingBatchFile: false,
    hasErrorUploadedBatchFile: null
}

/**
 * @description Reducer function for managing the state of batch files.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state of the batch files.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns {Object} - The updated state of the batch files.
 */
const ReducerBatchFile = (state = initialState, action) => {
    switch (action.type) {

        // All Batch Files Table
        case SET_BATCH_FILES_TABLE_PAGINATION: {
            return {
                ...state,
                pagination: action.payload
            }
        }

        // Get All Batch Files
        case GET_ALL_BATCH_FILES_BEGIN: {
            return {
                ...state,
                isLoadingAllBatchFiles: true
            }
        }
        case GET_ALL_BATCH_FILES_SUCCESS: {
            return {
                ...state,
                rowCount: action.payload?.count,
                allBatchFiles: action.payload?.rows,
                isLoadingAllBatchFiles: false,
                hasErrorAllBatchFiles: null
            }
        }
        case GET_ALL_BATCH_FILES_FAILURE: {
            return {
                ...state,
                allBatchFiles: null,
                isLoadingAllBatchFiles: false,
                hasErrorAllBatchFiles: action.payload
            }
        }

        // Download Batch File
        case DOWNLOAD_BATCH_FILE_BEGIN: {
            return {
                ...state,
                isDownloadingBatchFile: true
            }
        }
        case DOWNLOAD_BATCH_FILE_SUCCESS: {
            return {
                ...state,
                downloadedBatchFile: action.payload,
                isDownloadingBatchFile: false,
                hasErrorDownloadedBatchFile: null
            }
        }
        case DOWNLOAD_BATCH_FILE_FAILURE: {
            return {
                ...state,
                downloadedBatchFile: null,
                isDownloadingBatchFile: false,
                hasErrorDownloadedBatchFile: action.payload
            }
        }

        // Upload Batch File
        case UPLOAD_BATCH_FILE_BEGIN: {
            return {
                ...state,
                isUploadingBatchFile: true
            }
        }
        case UPLOAD_BATCH_FILE_SUCCESS: {
            return {
                ...state,
                uploadedBatchFile: action.payload,
                isUploadingBatchFile: false,
                hasErrorUploadedBatchFile: null
            }
        }
        case UPLOAD_BATCH_FILE_FAILURE: {
            return {
                ...state,
                uploadedBatchFile: null,
                isUploadingBatchFile: false,
                hasErrorUploadedBatchFile: action.payload
            }
        }

        default: return state
    }
}

export default ReducerBatchFile